@let showCountryMenu = this.showCountryMenu();
@let tenantConfigSettings = this.tenantConfigSettings();
@let isLoggedIn = this.isLoggedIn();

@for (language of translateService.getLangs(); track language) {
    <warema-header-menu-item
        [label]="'LANGUAGE_' + (language | uppercase) | translate"
        [selected]="translateService.getCurrentLang() === language"
        [title]="language"
        (click)="setLanguage.emit(language)"
    />
}

@if (showCountryMenu) {
    <warema-country-menu [appConfiguration]="tenantConfigSettings!" [loggedIn]="isLoggedIn" />
}
